import React from 'react';
import { DatedEvidence, Evidence } from '@eas/common-web';
import { EvidenceApiUrl, ExportTag, Permission } from '@enums';
import { useEvidencePermission } from '@utils/permission-hook';
import { useIntl } from 'react-intl';
import { NonStandardState } from '@models';
import { useColumns } from './non-standard-states-columns';
import { Fields } from './non-standard-states-fields';
import { useValidationSchema } from './non-standard-states-schema';

export function NonStandardStates() {
  const intl = useIntl();

  const columns = useColumns();

  const validationSchema = useValidationSchema();

  const permissions = useEvidencePermission({
    options: {
      NEW: [],
      EDIT: [Permission.Default.ADMINISTRATOR],
      REMOVE: [],
      REFRESH: [Permission.Default.ADMINISTRATOR],
      SHARE: [Permission.Default.ADMINISTRATOR],
      CHECK: [Permission.Default.ADMINISTRATOR],
      SAVE: [Permission.Default.ADMINISTRATOR],
      CLOSE: [Permission.Default.ADMINISTRATOR],
    },
  });

  const evidence = DatedEvidence.useDatedEvidence<NonStandardState>({
    version: 2,
    identifier: 'NON_STANDARD_STATE',
    apiProps: {
      url: EvidenceApiUrl.NON_STANDARD_STATE,
    },
    tableProps: {
      columns,
      tableName: intl.formatMessage({
        id: 'TAPIS__NON_STANDARD_STATE__TABLE__TITLE',
        defaultMessage: 'Číselník nestandardních stavů',
      }),
      reportTag: ExportTag.NON_STANDARD_STATE_GRID,
    },
    detailProps: {
      FieldsComponent: Fields,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'TAPIS__NON_STANDARD_STATE__DETAIL__TITLE',
          defaultMessage: 'Číselník nestandardních stavů',
        }),
        showBtn: permissions,
      },
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
